module.exports = __webpack_public_path__ + "img/bg11.3c568c7d.jpg";